// React Imports
import { ReactElement } from "react";

// Third Party Libraries Imports
import { ReactSVG } from "react-svg";

interface ViewRoleProps {
  onCancel: () => void;
  selectedRole: any;
  onDelete?: () => void;
  onEdit?: () => void;
}

const ViewRole: React.FC<ViewRoleProps> = ({
  onCancel,
  selectedRole,
  onDelete,
  onEdit,
}: ViewRoleProps): ReactElement => {
  return (
    <div className="view-role-container flex flex-col w-full px-5 md:px-10 box-border">
      <div className="flex flex-col md:flex-row items-start md:items-center justify-between pb-6 border-b-[1px] border-gray-900 mb-5">
        <h3 className=" text-lg md:text-xl">View Role: {selectedRole?.role}</h3>
        <div className="flex items-start md:items-center mt-3 md:mt-0">
          <button
            className="flex items-center rounded-full border-[1px] border-gray-900 py-[10px] px-4 text-base text-blue-500 bg-transparent ms-0 md:ms-3 cursor-pointer"
            onClick={onDelete}
          >
            Delete
            <img
              className="ms-3"
              src={"/images/delete.svg"}
              alt="export-customers"
            />
          </button>
          <button
            className="flex items-center rounded-full border-[1px] border-gray-900 py-[10px] px-4 text-base text-blue-500 bg-transparent ms-3 cursor-pointer"
            onClick={onEdit}
          >
            Edit
            <ReactSVG className="edit-icon stroke-blue-500 ms-3" src={"/images/edit.svg"} />
          </button>
        </div>
      </div>
      <div className="data border-[1px] border-gray-900 p-4">
        <div className="flex items-center pb-3 border-b-[1px] border-gray-900 mb-3">
          <p className="min-w-[130px] md:min-w-[200px]">name</p>
          <span className=" font-medium">{selectedRole?.role}</span>
        </div>
        <div className="flex items-center pb-3 border-b-[1px] border-gray-900 mb-3">
          <p className="min-w-[130px] md:min-w-[200px]">Description</p>
          <span className=" font-medium">{selectedRole?.description}</span>
        </div>
        <div className="flex items-center pb-3 border-b-[1px] border-gray-900 mb-3">
          <p className="min-w-[130px] md:min-w-[200px]">Permissions</p>
          <div className="flex items-center wrap">
            <span className=" font-medium">
              {selectedRole.permissions
                .map((permission: any) => permission.permission)
                .join(", ")}
            </span>
          </div>
        </div>
        <div className="flex items-center">
          <p className="min-w-[130px] md:min-w-[200px]">Assigned users</p>
          <div className="flex items-center flex-wrap gap-2">
            {selectedRole.admins.map((admin: any) => (
              <span className=" text-white py-1 px-3 bg-blue-500 rounded-full" key={admin.id}>{admin.name}</span>
            ))}
          </div>
        </div>
      </div>
      <div className="flex items-center justify-end mt-5">
        <button onClick={onCancel} className="w-1/2 md:w-1/3 border-[1px] border-blue-500 rounded-lg py-3">
          Cancel
        </button>
      </div>
    </div>
  );
};

export default ViewRole;
